import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DataTable, columnTypes } from 'yankees-react-utils';
import ReportNote from '../../../components/ReportNote';
import ReportCard from '../../../components/ReportCard';
import StyledNotesContainer from './StyledNotesContainer';
import useOpposingTeamSelector from '../../../utils/useOpposingTeamSelector';

const OpposingBatterMatchupNote = ({ pitcherId, batterId, showSpanish, doesHaveSpanishNoteCallback }) => {
    const { t: translate } = useTranslation();
    const opponent = useOpposingTeamSelector();
    const levelid = opponent.LevelIDData;
    const [hasMatchupNote, setHasMatchupNote] = useState(true);
    const hasMatchupNoteCallback = (data) => setHasMatchupNote(data);

    const doesHaveSpanishNote = (data) => {
        if (doesHaveSpanishNoteCallback) {
            doesHaveSpanishNoteCallback(data);
        }
    };

    return (
        <ReportCard title={translate('sections.opponent.player.matchup-notes')}>
            <StyledNotesContainer>
                {pitcherId && batterId && (
                    <DataTable
                        striped={false}
                        columns={[{
                            id: 'note',
                            type: columnTypes.TEXT,
                            transform: () => (
                                <ReportNote
                                    type="spgp"
                                    section={1}
                                    levelId={levelid}
                                    batterId={batterId}
                                    pitcherId={pitcherId}
                                    hasDataCallback={hasMatchupNoteCallback}
                                    showSpanish={showSpanish}
                                    doesHaveSpanishDataCallback={doesHaveSpanishNote}
                                />
                            ),
                        }]}
                        rows={[{}]}
                    />
                )}
                { !hasMatchupNote && <>{translate('sections.opponent.player.none-found')}</>}
            </StyledNotesContainer>
        </ReportCard>
    );
};

OpposingBatterMatchupNote.propTypes = {
    pitcherId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    batterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    showSpanish: PropTypes.bool,
    doesHaveSpanishNoteCallback: PropTypes.func,
};
OpposingBatterMatchupNote.defaultProps = {
    showSpanish: false,
    doesHaveSpanishNoteCallback: undefined,
};

export default OpposingBatterMatchupNote;
